import {HookClass} from "@dvrt/graphql-widgets";
import {useState} from "react";
import {Auth, useAuth} from "@/context/AuthProvider";
import {useDomainNameQuery} from "@/queries.generated";

import {CurrentAddressBookLazyQueryHookResult, useCurrentAddressBookLazyQuery} from "./queries.generated";
import {AddressBookEntryData} from "@/api";

export default class DataSource extends HookClass {
    protected domainId!: number;

    private currentAddressBookFetcher!: CurrentAddressBookLazyQueryHookResult[0];

    private domainName!: string;
    private setDomainName!: (v: string) => void;

    auth!: Auth;

    useHooks(domainId: number) {
        this.domainId = domainId;
        this.auth = useAuth();

        [this.domainName, this.setDomainName] = useState();

        [this.currentAddressBookFetcher] = useCurrentAddressBookLazyQuery({
            variables: {target: this.domainName},
            fetchPolicy: "no-cache",
        });

        useDomainNameQuery({
            variables: {id: this.domainId},
            onCompleted: (data) => {
                this.setDomainName(data.domains.items[0].name);
            },
        });
    }

    get loaded() {
        return this.domainName !== undefined;
    }

    async getCurrentAddressBookEntries(): Promise<AddressBookEntryData[]> {
        const {data} = await this.currentAddressBookFetcher();
        return data?.addressBook.entries || [];
    }
}
